import { render } from "./Props.vue?vue&type=template&id=744cee34"
import script from "./Props.vue?vue&type=script&lang=js"
export * from "./Props.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__